// AvatarImage
// ***********************************************************************************************************************
import * as React from "react";
import { Base } from "./../../framework/base";
import { Translations } from "./../../models/translations";
import { ToolButton } from "./toolButton";

export interface IAvatarImageProp {
    id?: string;
    border?: boolean;
    name?: string;
    image?: string;
    classes?: string;
    editable?: boolean;
    fileInputName?: string;
    showName?: boolean;
    tooltip?: string;
    removeTooltip?: string;
    imageClass?: string;
    longPressMs?: number;
    onClick?: () => void;
    onChange?: (file: File) => void;
    onClear?: () => void;
    onLongPress?: () => void;
    onError?: (message: string) => void;
}

export interface IAvatarImageState {
    file: File;
    backgroupdNumber: number;
}

export class AvatarImage extends React.Component<IAvatarImageProp, IAvatarImageState> {
    private pressTimer: number = 0;

    clearPressTimer = () => {
        clearTimeout(this.pressTimer);
        this.pressTimer = 0;
    };

    handleLinePress = (ev) => {
        const obj = this;
        //Set timer
        this.pressTimer = window.setTimeout(() => {
            //long press
            obj.clearPressTimer();
            obj.props.onLongPress();
        }, obj.props.longPressMs);
    };

    handleLineRelease = (ev) => {
        const props = this.props;
        //short press
        if (this.pressTimer > 0) {
            this.clearPressTimer();
            if (props.onClick) {
                props.onClick();
            }
        }
    };

    constructor(props) {
        super(props);
        this.state = { file: null, backgroupdNumber: Base.strToHashNumber(props.id, 114) };
    }

    componentDidUpdate(prevProps: IAvatarImageProp) {
        const props = this.props;
        if (prevProps.id === props.id) return;
        this.setState({ backgroupdNumber: Base.strToHashNumber(props.id, 114) });
    }

    handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const props = this.props;
        if (!props.editable || Base.isNullOrUndefined(e.target.files) || e.target.files.length < 1) return;
        const file = e.target.files[0];
        if (Base.isImageFile(file)) {
            props.onChange(file);
        } else {
            props.onError(Translations.SelectImageFile);
        }
    };

    handleClear = () => {
        this.props.onClear();
    };
    
    render() {
        const props = this.props;
        const name = props.name ? props.name.trim() : "";
        const names = name.split(" ");
        const fileInputName = props.fileInputName ? props.fileInputName : "image";
        const removeTooltip = props.removeTooltip ? props.removeTooltip : Translations.Remove;
        return (
            <div className={"avatar" + (props.classes ? " " + props.classes : "") + (props.editable ? " editable" : "") + (props.border ? " withBorder" : "")} title={props.tooltip}
                onClick={props.onClick ? (e) => { e.stopPropagation(); props.onClick(); } : null}
                onTouchStart={props.onLongPress && props.editable ? this.handleLinePress : null}
                onTouchEnd={props.onLongPress && props.editable ? this.handleLineRelease : null}
                onMouseDown={props.onLongPress && props.editable ? this.handleLinePress : null}
                onMouseUp={props.onLongPress && props.editable ? this.handleLineRelease : null}
                onMouseLeave={props.onLongPress && props.editable ? this.handleLineRelease : null}
            >
                <label>
                    {(!!props.image || !!props.imageClass) &&
                        <span className={"image" + (props.imageClass ? " " + props.imageClass : "")} style={props.image ? { backgroundImage: "url(" + props.image + ")" } : null}></span>
                    }
                    {!props.image && !props.imageClass &&
                        <span className={"initials bg" + this.state.backgroupdNumber.toString(10)}>{name ? (names[0] ? (names[0][0] + (names[1] ? names[1][0] : "")) : "") : "?"}</span>
                    }
                    {props.showName && !!name &&
                        <span className="name">{name}</span>
                    }
                    {!!props.editable &&
                        <input type="file" name={fileInputName} className="file" style={{ display: "none" }} multiple={false} onChange={this.handleFileChange} />
                    }
                    {(!!props.editable && !!props.image && !!props.onClear) &&
                        <ToolButton
                            classes={"doClose smallButton"}
                            stopPropagation={true}
                            tooltip={removeTooltip}
                            onClick={this.handleClear}
                        />
                    }
                </label>
            </div>
        );
    }
}